import { Link } from 'react-router-dom';
import Footer from '../components/Footer.jsx';

export default function NotFoundPage() {
  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '100vh',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          textAlign: 'center',
          padding: '1rem',
          gap: '1rem',
        }}
      >
        <h1>Page not found</h1>
        <Link to="/">
          <u>Back to Logan Holmes Runs</u>
        </Link>
      </div>
      <Footer />
    </>
  );
}
